import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return {x: 0, y: 0}
    },
    routes: [{
        // =============================================================================
        // MAIN LAYOUT ROUTES
        // =============================================================================
        path: '',
        component: () => import('./layouts/main/Main.vue'),
        children: [
            {
                path: '/',
                name: 'home',
                component: () => import('./views/Home.vue'),
                meta: {
                    pageTitle: '',
                    rule: 'editor'
                }
            },

            {
                path: '/success',
                name: 'success',
                component: () => import('./views/stripe/Success.vue'),
            },
            {
                path: '/error',
                name: 'error',
                component: () => import('./views/stripe/Error.vue'),
            },

            {
                path: '/reports/list',
                name: 'reports-list',
                component: () => import('@/views/Reports/ReportsList_deleted.vue'),
                meta: {
                    pageTitle: 'Λίστα Αναφορών',
                    rule: 'editor'
                }
            },
            {
                path: '/reports/table',
                name: 'reports-table',
                component: () => import('@/views/Reports/ReportsTable.vue'),
                meta: {
                    pageTitle: 'Πίνακας Αναφορών',
                    rule: 'editor'
                }
            },
            {
                path: '/reports/market-places',
                name: 'reports-market-places',
                component: () => import('@/views/Reports/ReportsSkroutz.vue'),
                meta: {
                    pageTitle: 'Αναφορά Market Places',
                    rule: 'editor'
                }
            },
            {
                path: '/products/total_urls',
                name: 'total-urls',
                component: () => import('@/views/Products/TotalUrls.vue'),
                meta: {
                    pageTitle: 'Σύνδεσμοι προϊόντων',
                    rule: 'editor'
                }
            },
            {
                path: '/products/list',
                name: 'products-list',
                component: () => import('@/views/Products/ProductsList.vue'),
                meta: {
                    pageTitle: 'Προϊόντα',
                    rule: 'editor'
                }
            },
            {
                path: '/products/edit/:id?',
                name: 'products-edit',
                component: () => import('@/views/Products/ProductsEdit.vue'),
                meta: {
                    breadcrumb: [
                        {title: 'Dashboard', url: '/'},
                        {title: 'Προϊόντα', url: '/products/list'},
                        {title: 'Τίτλος προϊόντος', active: true}
                    ],
                    pageTitle: 'Επεξεργασία',
                    rule: 'editor'
                }
            },
            {
                path: '/shops',
                name: 'shops',
                component: () => import('@/views/Shops.vue'),
                meta: {
                    pageTitle: 'Καταστήματα',
                    rule: 'editor'
                }
            },
            {
                path: '/groups',
                name: 'groups',
                component: () => import('@/views/Groups.vue'),
                meta: {
                    pageTitle: 'Ομάδες',
                    rule: 'editor'
                }
            },
            {
                path: '/settings/sources',
                name: 'settings-sources',
                component: () => import('@/views/Settings/SettingsSources.vue'),
                meta: {
                    pageTitle: 'Πηγές',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/categories',
                name: 'settings-categories',
                component: () => import('@/views/Settings/SettingsCategories.vue'),
                meta: {
                    pageTitle: 'Κατηγορίες',
                    rule: 'editor'
                }
            },
            {
                path: '/settings/users',
                name: 'settings-users',
                component: () => import('@/views/Settings/SettingsUsers.vue'),
                meta: {
                    pageTitle: 'Χρήστες',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/sync',
                name: 'settings-sync',
                component: () => import('@/views/Settings/SettingsSync.vue'),
                meta: {
                    pageTitle: 'Παράμετροι XML',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/sync-xls',
                name: 'settings-sync-xls',
                component: () => import('@/views/Settings/SettingExcel.vue'),
                meta: {
                    pageTitle: 'Παράμετροι Excel',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/importlinks',
                name: 'settings-import-links',
                component: () => import('@/views/Settings/SettingsUploadSkroutzLinks.vue'),
                meta: {
                    pageTitle: 'Εισαγωγή συνδέσμων',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/schedule',
                name: 'settings-schedule',
                component: () => import('@/views/Settings/SettingLaravelSync.vue'),
                meta: {
                    pageTitle: 'Προγραμματισμένες εργασίες',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/importlinks',
                name: 'settings-importlinks',
                component: () => import('@/views/Settings/SettingsUploadSkroutzLinks.vue'),
                meta: {
                    pageTitle: 'Εισγωγή συνδέσμων',
                    rule: 'admin'
                }
            },
            {
                path: '/support',
                name: 'page-support',
                component: () => import('@/views/Pages/Support.vue'),
                meta: {
                    pageTitle: '',
                    rule: 'editor'
                }
            },
            {
                path: '/settings/import-products-n-links',
                name: 'settings-import-products-n-links',
                component: () => import('@/views/Settings/SettingsImports.vue'),
                meta: {
                    pageTitle: 'Παράμετροι Πεδίων Εισαγωγής',
                    rule: 'admin'
                }
            },
            {
                path: '/settings/dynamic-pricing',
                name: 'settings-dynamic-pricing',
                component: () => import('@/views/Settings/SettingDynamicPricing.vue'),
                meta: {
                    pageTitle: 'Προγραμματισμένες εργασίες',
                    rule: 'admin'
                }
            },
            {
                path: '/notifications',
                name: 'notifications',
                component: () => import('@/views/Notifications/NotificationsList.vue'),
                meta: {
                    pageTitle: 'Ειδοποιήσεις',
                    rule: 'editor'
                }
            },
            {
                path: '/eshops',
                name: 'eshops',
                component: () => import('@/views/Eshops/EshopsList.vue'),
                meta: {
                    pageTitle: 'Ειδοποιήσεις',
                    rule: 'admin'
                }
            },
            {
                path: '/eshops/edit/:id?',
                name: 'eshops-edit',
                component: () => import('@/views/Eshops/EshopsEdit.vue'),
                meta: {
                    breadcrumb: [
                        {title: 'Dashboard', url: '/'},
                        {title: 'Πηγές', url: '/eshops/list'},
                        {title: 'Τίτλος πηγής', active: true}
                    ],
                    pageTitle: 'Επεξεργασία',
                    rule: 'admin'
                }
            },
            {
                path: '/prices-changes',
                name: 'prices-changes',
                component: () => import('@/views/Admin/PricesChangedList.vue'),
                meta: {
                    pageTitle: 'Prices Changed list',
                    rule: 'admin'
                }
            },
            {
                path: '/log/:category?',
                name: 'log/dynamic-pricing',
                component: () => import('@/views/Logs/LogsList.vue'),
                meta: {
                    pageTitle: 'Log list',
                    rule: 'admin'
                }
            },
        ],
    },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/Pages/Login.vue'),
                    meta: {
                        rule: 'editor'
                    },
                },
                {
                    path: '/recovery',
                    name: 'page-recovery',
                    component: () => import('@/views/Pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'editor'
                    },
                },
                {
                    path: '/resetPassword/:reset_token',
                    name: 'page-reset-password',
                    component: () => import('@/views/Pages/ResetPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/Pages/Error404.vue')
                },
                {
                    path: '/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/Pages/NotAuthorized.vue')
                },


            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/error-404'
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login', '/recovery', '/resetPassword', '/error-404'];


    let authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('accessToken');

    if (to.path.includes('resetPassword')) {
        authRequired = false;
    }

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
})

export default router
